import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface ProgressProps {
  percent: number | null;
  label: string;
  tone?: 'goal' | 'project';
}

/**
 * «Нет данных» и «ноль процентов» — разные состояния: у цели без задач
 * прогресса ещё нет, и показывать пустую полосу как провал нельзя.
 */
export function Progress({ percent, label, tone = 'goal' }: ProgressProps) {
  const { t } = useTranslation();

  if (percent == null) {
    return <p className="text-xs text-muted">{t('goal.noProgressData')}</p>;
  }

  return (
    <div className="flex items-center gap-3">
      <div
        role="progressbar"
        aria-label={label}
        aria-valuenow={Math.round(percent)}
        aria-valuemin={0}
        aria-valuemax={100}
        className="h-1.5 flex-1 overflow-hidden rounded-full bg-surface-2"
      >
        <div
          className={cn('h-full rounded-full', tone === 'goal' ? 'bg-far' : 'bg-mid')}
          style={{ inlineSize: `${Math.max(2, percent)}%` }}
        />
      </div>
      <span className="text-xs tabular-nums text-ink-2">{Math.round(percent)}%</span>
    </div>
  );
}
